export interface FileWindowState { ids: string[]; active: string | null }
export const emptyFileWindows: FileWindowState = { ids: [], active: null };
export function openFileWindow(state: FileWindowState, id: string): FileWindowState {
  return { ids: state.ids.includes(id) ? state.ids : [...state.ids, id], active: id };
}
export function closeFileWindow(state: FileWindowState, id: string): FileWindowState {
  const ids = state.ids.filter(value => value !== id);
  return { ids, active: state.active === id ? ids.at(-1) ?? null : state.active };
}
